// ============================================
// CÓDIGO JAVASCRIPT COMPLETO CORREGIDO
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    console.log("🚀 Iniciando todos los componentes...");
    
    // 1. INICIALIZAR PRIMER CARRUSEL (SWIPER)
    initSwiperCarousel();
    
    // 2. INICIALIZAR SEGUNDO CARRUSEL (PRODUCTOS)
    initProductCarousel();
    
    // 3. INICIALIZAR COMPONENTES GENERALES
    initGeneralComponents();
    
    console.log("✅ Todos los componentes inicializados");
});

// ============================================
// 1. PRIMER CARRUSEL - Swiper (funcional)
// ============================================

function initSwiperCarousel() {
    console.log("🎬 Inicializando carrusel Swiper...");
    
    // Verificar que Swiper esté disponible
    if (typeof Swiper === 'undefined') {
        console.error("❌ ERROR: Swiper no está cargado");
        console.error("Asegúrate de incluir: <script src='https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js'></script>");
        return;
    }
    
    // Verificar que el elemento exista
    const swiperElement = document.querySelector('.large-carousel');
    if (!swiperElement) {
        console.error("❌ No se encontró .large-carousel");
        return;
    }
    
    try {
        // Inicializar Swiper
        const swiper = new Swiper('.large-carousel', {
            // Configuración básica
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 800,
            
            // Autoplay
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            
            // Paginación
            pagination: {
                el: '.carousel-pagination',
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            
            // Efectos
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });
        
        console.log("✅ Carrusel Swiper inicializado correctamente");
        
        // Controlar autoplay al interactuar
        swiperElement.addEventListener('mouseenter', function() {
            swiper.autoplay.stop();
            console.log("⏸️ Swiper pausado (mouse enter)");
        });
        
        swiperElement.addEventListener('mouseleave', function() {
            swiper.autoplay.start();
            console.log("▶️ Swiper reanudado (mouse leave)");
        });
        
    } catch (error) {
        console.error("❌ Error al inicializar Swiper:", error);
    }
}

// ============================================
// 2. SEGUNDO CARRUSEL - CORREGIDO PARA RESPONSIVE
// ============================================

function initProductCarousel() {
    console.log("🎬 Inicializando carrusel de productos...");
    
    // Elementos del DOM
    const track = document.getElementById('carouselTrack');
    const prevBtn = document.getElementById('carouselPrev');
    const nextBtn = document.getElementById('carouselNext');
    const indicators = document.querySelectorAll('.carousel-indicator[data-slide]');
    const wrapper = document.querySelector('.carousel-wrapper');
    
    // Verificar elementos
    if (!track || !wrapper) {
        console.error("❌ ERROR: Elementos del carrusel no encontrados");
        return;
    }
    
    console.log("✅ Elementos encontrados");
    
    // Configuración
    let currentSlide = 0;
    let autoSlideInterval;
    let slidesPerView = 4;
    
    // Calcular slides por vista según el tamaño de pantalla
    function calculateSlidesPerView() {
        const width = window.innerWidth;
        
        if (width < 576) return 1;
        if (width < 768) return 1;
        if (width < 992) return 2;
        if (width < 1200) return 3;
        return 4;
    }
    
    // Calcular slides totales
    function calculateTotalSlides() {
        const cards = document.querySelectorAll('.carousel-product-card');
        return Math.ceil(cards.length / slidesPerView);
    }
    
    // Actualizar configuración responsive
    function updateResponsiveConfig() {
        const newSlidesPerView = calculateSlidesPerView();
        
        if (newSlidesPerView !== slidesPerView) {
            slidesPerView = newSlidesPerView;
            totalSlides = calculateTotalSlides();
            
            // Ajustar slide actual
            if (currentSlide >= totalSlides) {
                currentSlide = Math.max(0, totalSlides - 1);
            }
            
            moveToSlide(currentSlide);
        }
    }
    
    // Inicializar valores
    slidesPerView = calculateSlidesPerView();
    let totalSlides = calculateTotalSlides();
    
    console.log(`📊 Config: ${slidesPerView} productos por vista, ${totalSlides} slides`);
    
    // Función para mover el carrusel
    function moveToSlide(slideIndex) {
        // Validar índice
        if (slideIndex < 0) slideIndex = 0;
        if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
        
        currentSlide = slideIndex;
        
        // Calcular desplazamiento exacto
        const translateX = -(currentSlide * (100 / slidesPerView) * slidesPerView);
        track.style.transform = `translateX(${translateX}%)`;
        
        console.log(`📍 Slide ${currentSlide + 1}/${totalSlides}, translateX: ${translateX}%`);
        
        // Actualizar indicadores
        updateIndicators();
    }
    
    // Función para actualizar indicadores
    function updateIndicators() {
        indicators.forEach((indicator, index) => {
            if (index === currentSlide) {
                indicator.classList.add('active');
            } else {
                indicator.classList.remove('active');
            }
        });
    }
    
    // Función para siguiente slide
    function nextSlide() {
        if (currentSlide >= totalSlides - 1) {
            moveToSlide(0);
        } else {
            moveToSlide(currentSlide + 1);
        }
    }
    
    // Función para slide anterior
    function prevSlide() {
        if (currentSlide <= 0) {
            moveToSlide(totalSlides - 1);
        } else {
            moveToSlide(currentSlide - 1);
        }
    }
    
    // Autoplay
    function startAutoPlay() {
        stopAutoPlay();
        autoSlideInterval = setInterval(nextSlide, 3000);
        console.log("▶️ Autoplay iniciado (cada 3 segundos)");
    }
    
    function stopAutoPlay() {
        if (autoSlideInterval) {
            clearInterval(autoSlideInterval);
            autoSlideInterval = null;
        }
    }
    
    // Event Listeners para botones
    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            console.log("⬅️ Botón PREV clickeado");
            stopAutoPlay();
            prevSlide();
            setTimeout(startAutoPlay, 5000);
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            console.log("➡️ Botón NEXT clickeado");
            stopAutoPlay();
            nextSlide();
            setTimeout(startAutoPlay, 5000);
        });
    }
    
    // Event Listeners para indicadores
    indicators.forEach(indicator => {
        indicator.addEventListener('click', function() {
            const slideIndex = parseInt(this.getAttribute('data-slide'));
            console.log(`🔘 Indicador ${slideIndex} clickeado`);
            stopAutoPlay();
            moveToSlide(slideIndex);
            setTimeout(startAutoPlay, 5000);
        });
    });
    
    // Pausar autoplay al interactuar
    if (wrapper) {
        wrapper.addEventListener('mouseenter', stopAutoPlay);
        wrapper.addEventListener('mouseleave', startAutoPlay);
    }
    
    // Actualizar responsive al cambiar tamaño de ventana
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            updateResponsiveConfig();
        }, 250);
    });
    
    // Inicializar
    updateResponsiveConfig();
    moveToSlide(0);
    startAutoPlay();
    
    console.log("✅ Carrusel de productos inicializado correctamente");
}

// ============================================
// 3. COMPONENTES GENERALES
// ============================================

function initGeneralComponents() {
    console.log("🔧 Inicializando componentes generales...");
    
    // Efecto de hover en botones "COMPRAR"
    const buyButtons = document.querySelectorAll('.product-shop-btn, .carousel-product-btn, .banner-buy-link, .add-to-cart-btn, .banner-shop-btn-black');
    
    buyButtons.forEach(button => {
        button.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-2px)';
            this.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
        });
        
        button.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
            this.style.boxShadow = 'none';
        });
    });
    
    // Menú desplegable mejorado
    const dropdowns = document.querySelectorAll('.dropdown');
    
    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('mouseenter', function() {
            const content = this.querySelector('.dropdown-content');
            if (content) {
                content.style.display = 'block';
            }
        });
        
        dropdown.addEventListener('mouseleave', function() {
            const content = this.querySelector('.dropdown-content');
            if (content) {
                content.style.display = 'none';
            }
        });
    });
    
    // Corrección para botones en móviles
    const allButtons = document.querySelectorAll('button, .product-shop-btn, .banner-buy-link, .add-to-cart-btn');
    allButtons.forEach(button => {
        button.addEventListener('touchstart', function() {
            this.style.transform = 'scale(0.98)';
        });
        
        button.addEventListener('touchend', function() {
            this.style.transform = 'scale(1)';
        });
    });
    
    // Efectos de zoom ya están manejados por CSS puro
    
    console.log("✅ Componentes generales inicializados");
}

















// ============================================
// SECTION 5 - FUNCIONALIDAD DE CATEGORÍAS
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    console.log("🚀 Inicializando navegación de categorías...");
    
    // Elementos del DOM
    const categoryTabs = document.querySelectorAll('.category-tab');
    const productGrids = document.querySelectorAll('.category-products-grid');
    const indicatorLine = document.querySelector('.indicator-line');
    
    // Verificar elementos
    if (categoryTabs.length === 0 || productGrids.length === 0) {
        console.error("❌ ERROR: No se encontraron pestañas o grids de categorías");
        return;
    }
    
    console.log(`✅ Encontradas ${categoryTabs.length} pestañas y ${productGrids.length} grids`);
    
    // Inicializar el indicador
    initTabIndicator();
    
    // Agregar event listeners a las pestañas
    categoryTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const category = this.getAttribute('data-category');
            switchCategory(category, this);
        });
        
        // Efectos hover
        tab.addEventListener('mouseenter', function() {
            if (!this.classList.contains('active')) {
                this.style.color = '#333';
            }
        });
        
        tab.addEventListener('mouseleave', function() {
            if (!this.classList.contains('active')) {
                this.style.color = '';
            }
        });
    });
    
    // Función para inicializar el indicador
    function initTabIndicator() {
        const activeTab = document.querySelector('.category-tab.active');
        if (activeTab && indicatorLine) {
            updateTabIndicator(activeTab);
        }
    }
    
    // Función para cambiar de categoría
    function switchCategory(categoryId, clickedTab) {
        console.log(`🔄 Cambiando a categoría: ${categoryId}`);
        
        // Remover clase active de todas las pestañas
        categoryTabs.forEach(tab => {
            tab.classList.remove('active');
            tab.style.color = '';
        });
        
        // Remover clase active de todos los grids
        productGrids.forEach(grid => {
            grid.classList.remove('active');
        });
        
        // Agregar clase active a la pestaña seleccionada
        clickedTab.classList.add('active');
        
        // Mostrar grid de la categoría seleccionada
        const selectedGrid = document.getElementById(`${categoryId}-grid`);
        if (selectedGrid) {
            setTimeout(() => {
                selectedGrid.classList.add('active');
            }, 50);
        }
        
        // Actualizar indicador visual
        updateTabIndicator(clickedTab);
    }
    
    // Función para actualizar el indicador visual
    function updateTabIndicator(activeTab) {
        if (!activeTab || !indicatorLine) return;
        
        const tabRect = activeTab.getBoundingClientRect();
        const tabsContainer = activeTab.parentElement;
        const containerRect = tabsContainer.getBoundingClientRect();
        
        // Calcular posición relativa
        const leftPosition = tabRect.left - containerRect.left;
        
        // Actualizar indicador
        indicatorLine.style.width = `${tabRect.width}px`;
        indicatorLine.style.transform = `translateX(${leftPosition}px)`;
        indicatorLine.style.opacity = '1';
    }
    
    // Actualizar indicador al cambiar tamaño de ventana
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const activeTab = document.querySelector('.category-tab.active');
            if (activeTab) {
                updateTabIndicator(activeTab);
            }
        }, 250);
    });
});

// Efectos hover en botones de compra
document.addEventListener('DOMContentLoaded', function() {
    const buyButtons = document.querySelectorAll('.category-buy-btn');
    
    buyButtons.forEach(button => {
        button.addEventListener('mouseenter', function() {
            this.style.color = '#333';
        });
        
        button.addEventListener('mouseleave', function() {
            this.style.color = '#00C08B';
        });
    });
});